import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";

const BasicDropDownList = ({
  id,
  label,
  valueField,
  textField,
  onChange,
  data = [],
  value,
  required,
  disabled,
}) => {
  return (
    <DropDownList
      name={id}
      id={id}
      label={label ? label : undefined}
      style={{ width: "100%" }}
      data={data}
      dataItemKey={valueField ?? "value"}
      textField={textField ?? "text"}
      value={value && data ? data.find((a) => a.value === value) : ""}
      onChange={onChange}
      required={required}
      disabled={disabled}
    />
  );
};

export default BasicDropDownList;
